@if (absenceEmployee(); as absenceEmployee) {
  <mat-card class="qaroni-card-bg-background mat-elevation-z0">
    <mat-card-content class="flex flex-col gap-4 p-4">
      <h3 class="m-0 text-base font-bold text-primary-30" i18n>Resumen</h3>

      <dl class="m-0 grid grid-cols-[auto_1fr] gap-x-4 gap-y-2.5 text-sm">
        <dt class="text-neutral-40" i18n>Tiempo</dt>
        <dd class="m-0 text-right">{{ duration || '—' }}</dd>

        <dt class="text-neutral-40" i18n>Confirmación</dt>
        <dd class="m-0 text-right">
          @if (absenceEmployee.confirm) {
            {{ absenceEmployee.confirmDate | date: 'dd/MM/yyyy' }}
          } @else {
            <ng-container i18n>Sin confirmar</ng-container>
          }
        </dd>

        <dt class="text-neutral-40" i18n>Validación</dt>
        <dd class="m-0 text-right">
          @if (absenceEmployee.validatedBy) {
            {{ absenceEmployee.validatedBy.fullName }} ·
            {{ absenceEmployee.validationDate | date: 'dd/MM/yyyy' }}
          } @else {
            <ng-container i18n>Sin validar</ng-container>
          }
        </dd>

        <dt class="text-neutral-40" i18n>Creada</dt>
        <dd class="m-0 text-right">
          {{ absenceEmployee.creationDate | date: 'dd/MM/yyyy' }}
        </dd>

        <dt class="text-neutral-40" i18n>Última edición</dt>
        <dd class="m-0 text-right">
          @if (absenceEmployee.lastEditedBy) {
            {{ absenceEmployee.lastEditedBy.fullName }} ·
          }
          {{ absenceEmployee.lastUpdateDate | date: 'dd/MM/yyyy' }}
        </dd>
      </dl>

      <ng-content />
    </mat-card-content>
  </mat-card>
}
